import { ChangeDetectionStrategy, Component, computed, HostBinding, input } from '@angular/core';
import { AnimationDuration, getAnimationAppearDisappearWithHeight } from '@examdojo/animation';
import { Icon, IconComponent } from '@examdojo/core/icon';
import { BannerContent, BannerType } from './banner.model';

interface BannerTypeConfig {
  containerClass: string;
  icon: Icon;
}

const BANNER_TYPE_CONFIG: Record<BannerType, BannerTypeConfig> = {
  [BannerType.Warning]: {
    containerClass: 'border-b-amber-300 bg-amber-200 text-amber-700',
    icon: 'triangle-exclamation',
  },
  [BannerType.Info]: {
    containerClass: 'border-b-neutral-300 bg-neutral-100 text-neutral-700',
    icon: 'circle-info',
  },
};

@Component({
  selector: 'dojo-banner',
  imports: [IconComponent],
  templateUrl: './banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block w-full' },
  animations: [
    getAnimationAppearDisappearWithHeight({ enter: AnimationDuration.Medium, leave: AnimationDuration.Long }),
  ],
})
export class BannerComponent {
  readonly content = input.required<BannerContent>();
  readonly dataTest = input<string | null>(null);

  protected readonly bannerType = computed<BannerType>(() => {
    const msg = this.content();
    return typeof msg === 'string' ? BannerType.Info : msg.type;
  });

  protected readonly bannerMessage = computed(() => {
    const msg = this.content();
    return typeof msg === 'string' ? msg : msg.message;
  });

  protected readonly bannerConfig = computed(() => BANNER_TYPE_CONFIG[this.bannerType()]);

  @HostBinding('@appearDisappearWithHeight') protected readonly animation = true;
  @HostBinding('attr.data-test') get dataTestAttr() {
    return this.dataTest();
  }
}
